import { Component, Injector, OnInit } from '@angular/core';

import { ActionsAnalytics, CategoriesAnalytics } from '@app/services/analytics/models/analytics.enum';
import { StorageService } from '@app/services/storage';
import { UserService } from '@app/services/user/user.service';
import { BasePageDirective } from '@app/shared/bases/base.page';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.page.html',
  styleUrls: ['./configuration.page.scss']
})
export class ConfigurationPage extends BasePageDirective implements OnInit {
  infoBoolean!: boolean;
  sendData = {};
  constructor(injector: Injector, public userService: UserService, private storageService: StorageService) {
    super(injector);
  }

  async ngOnInit() {
    this.infoBoolean = await this.storageService.getCheckOfficeService();
  }

  sendAnalyticsEvent(_event: boolean) {
    const switchPosition: string = _event ? 'si' : 'no';
    this.analyticsService.sendEvent(CategoriesAnalytics.CONFIGURATION_SELECTED, {
      [ActionsAnalytics.CLICKACTION]: `${ActionsAnalytics.OFFICESERVICES}_${switchPosition}`
    });
  }

  checkChange(event: boolean) {
    this.sendAnalyticsEvent(event);
    this.sendData = { headquarters_switch: event };
    this.userService.updateUserConfiguration(this.sendData).subscribe((config) => {
      this.storageService.setCheckOfficeService(Boolean(config.headquartersSwitch));
    });
  }
}
